export const environment = {
  production: false,
  apiUrl: "https://dev.ai-api.photo-qc.davaco.cloud",
  auth: {
    clientId: "06e4c767-b293-4d6c-a6dd-920f94370c18",
    authority: "https://login.microsoftonline.com/20266eb8-0c6e-4253-bbdb-e7db3a9dc961",
    apiScope: "api://06e4c767-b293-4d6c-a6dd-920f94370c18/access_as_user",
  },
};
